'use strict';

define('features/favorites',[
  'jquery',
  'lib/util/langFromUrl',
  'lib/util/tda.config',
  'cookies',
  'webStorage',
  'lib/page-cache',
  'lib/services/offers-service',
  'lib/transforms/offers.tmpl.common',
  'lib/util/zip',
  'lib/animations/offers.animations',
  'lib/analytics/pageload',
  'lib/analytics/click',
  'lib/analytics/context.add',
  'lib/analytics/blocks/index',

  // side effect includes
  'lib/helpers/offer-bundle',
  'bat',
  'componentIsotope'
], function (
  $,
  langFromUrl,
  tdaConfig,
  cookies,
  ws,
  PageCache,
  offersServiceFactory,
  xformOffersCommon,
  zip,
  offersAnimations,
  anPageLoad,
  anClicks,
  anAddContext,
  blocks
) {
  var offersService = offersServiceFactory(tdaConfig.offers.r2_api_key);
  // move to external, for now use what's found in shared-templates.xsl
  var __lang = langFromUrl();
  var __favKey = tdaConfig.tda.code + 'favs_' + __lang;

  function __favItemCount() {
    var currStore = ws.getLocalStorage().getItem(__favKey);
    if (!currStore) {
      return 0;
    }
    return JSON.parse(currStore).length;
  }

  // get the length of favs, and update the header area
  function __favsHeader() {
    var favsLength = __favItemCount();
    var $favCountNav = $('.favorite-count');
    var $favCountNum = $('.number-of-favorites'); // favs page DOM element
    if (favsLength > 0) {
      $favCountNav.addClass('is-showing').html(String(favsLength));
      $favCountNum.html(String(favsLength));
    } else {
      $favCountNav.removeClass('is-showing');
      $favCountNum.html('0');
      $(window).trigger('LAST_FAVORITE_REMOVED');
    }
  }

  function __doDataLayerKm($target) {
    if ($target.hasClass('favorited')) {
      $target.data({
        km: '',
        linktext: 'favorite button'
      });
    } else {
      $target.data({
        km: 'km-offer-fav-click',
        linktext: 'favorite button'
      });
    }
  }

  // NEW STUFF!! transition old favs to use module-like version
  function __favItemToObj($target) {
    var $el = $($target);
    return {
      id: $el.data('id'),
      year: $el.data('year'),
      series: $el.data('series'),
      expire: $el.data('expire'),
      // expireShort: $el.data('expireShort'),
      type: $el.data('offerType'),
      timestamp: Date.now()
    };
  }

  // returns indexOf the found obj
  // TIM, silly to have both __favItemIndex AND __favItemExists?
  // but, sometimes we just want the boolean (__faveItemExists), and other times we want it's index
  function __favItemIndex(favsArr, favItemObj) {
    return favsArr.findIndex(function (item) {
      return item.id === favItemObj.id; // this part should be common
    });
  }

  // returns boolean, does this favItemObj exist?
  // switch to accept array, and findIndex on that
  function __favItemExists(favItemObj) {
    var currStore = ws.getLocalStorage().getItem(__favKey);
    // if there's no currentStore, just bail now;
    if (!currStore) {
      return false;
    }
    var favsArr = JSON.parse(currStore); // move to var
    var foundIndex = __favItemIndex(favsArr, favItemObj);
    if (foundIndex >= 0) {
      return true;
    }
    return false;
  }

  function __modifyStore(favItemObj) {
    var currStore = ws.getLocalStorage().getItem(__favKey);
    var favsArr = [];

    // if we have items already
    if (__favItemCount()) {
      favsArr = JSON.parse(currStore);
      if (__favItemExists(favItemObj)) {
        // item exists, does that ALWAYS mean that we want to remove it?
        // TODO: move to drop function
        var foundIndex = __favItemIndex(favsArr, favItemObj);
        favsArr.splice(foundIndex, 1);
        ws.getLocalStorage().setItem(__favKey, JSON.stringify(favsArr));
        // if we still have items left, update the store
        if (__favItemCount() == 0) {
          ws.getLocalStorage().removeItem(__favKey);
        }
      } else {
        favsArr.push(favItemObj);
        ws.getLocalStorage().setItem(__favKey, JSON.stringify(favsArr));
      }

    // It's empty, just update
    } else {
      favsArr.push(favItemObj);
      ws.getLocalStorage().setItem(__favKey, JSON.stringify(favsArr));
    }
    // trigger this custom event (listened for in modules.favorites)
    PageCache.set('favs.store', favsArr);
  }

  function __addRemove($target) {
    var favItemObj = __favItemToObj($target);
    __doDataLayerKm($target);
    $($target).toggleClass('favorited');
    __modifyStore(favItemObj);
    __favsHeader();
  }

  // returns a string of offerIds
  function __favOfferIds() {
    var favs = JSON.parse(ws.getLocalStorage().getItem(__favKey));
    var favIds = favs.map(function (item) {
      return item.id;
    });
    return favIds.toString();
  }

  return {
    addRemove: __addRemove,
    // toggle the class on the card or module
    markFav: function ($target) {
      var favItemObj = __favItemToObj($target);
      if (__favItemExists(favItemObj)) {
        $target.addClass('favorited');
      }
      __doDataLayerKm($target);
      __favsHeader();
    },

    toggleFav: function ($target) {
      var favItemObj = __favItemToObj($target);
      if (__favItemExists(favItemObj)) {
        $target.addClass('favorited');
      } else {
        $target.removeClass('favorited');
      }
      __favsHeader();
    },

    favCount: __favItemCount(),
    favKey: __favKey,
    gimmeFavs: JSON.parse(ws.getLocalStorage().getItem(__favKey)),

    // invoked in header.js and navigation.favorites.js
    mainNav: function () {
      var dealer_code_rti = cookies.getItem('dealer_code_rti');
      var $mainNavFav = $('.nav-main-lead > li > a[href$="favorites/index.page"]');

      // GXP (RTI, Real Time Inventory), hide favorites functionality altogether
      if (dealer_code_rti === 'true') {
        $mainNavFav.hide();
      } else {
        if (!$mainNavFav.is('visible')) {
          $mainNavFav.show();
        }
        __favsHeader();
      }
    },

    drawNoFavs: function () {
      $('#no-favorites-display').removeClass('hidden');
      $('#favorites-display').hide();
      window.bat.util.loader.hideLoader();
    },

    // for use by the actual /favorites page
    drawPage: function (el) {
      var self = this;
      self.$el = $(el);
      var favCount = __favItemCount();
      // no favorites? go no further.
      if (!favCount) {
        this.drawNoFavs();
        this.analyticsFavs();
        return;
      }

      var favIdStrings = __favOfferIds();
      var cacheId = 'favorites.' + favIdStrings;

      PageCache.await(cacheId)
        .then(function (res) {
          return xformOffersCommon(res.offerBundle.offers);
        })
        .then(function (offers) {
          $('#favorites-display').removeClass('hidden');
          var cardsHTML = Handlebars.hcompile($('#template-offer-card').html(), { items: offers });
          var $newItems = $(cardsHTML);
          $('#favorite-offers-isotope').isotope();
          $('#favorite-offers-isotope').isotope('insert', $newItems);
          offersAnimations.animateOfferCards();
          self.mainNav();
          self.analyticsFavs(offers);
          self.favListeners();
          window.bat.util.loader.hideLoader();

          // HOLY HELL IT JUST KEEPS GOING AND going
          $('.isotope-container').on('click', '.favorite-button', function (e) {
            var $this = $(this);
            var $thisParentCard = $this.parents('.card');

            setTimeout(function () {
              $('#favorite-offers-isotope').isotope('remove', $thisParentCard);
            }, 0);

            setTimeout(function () {
              var $allRemainingCards = $('.isotope-container .card');
              var remainingCardsLen = $allRemainingCards.length;
              $.each($allRemainingCards, function (index) {
                var $thisCard = $(this);
                var currDataLayer = $thisCard.find('a.datalayer-link').data('layer');
                var dataToAdd = {
                  offer_list_result_count: remainingCardsLen.toString(),
                  list_result_count: remainingCardsLen.toString(),
                  list_item_index: (index + 1).toString()
                };
                $.extend(currDataLayer, dataToAdd);
                $thisCard.data('layer', currDataLayer);
              });
              if (!remainingCardsLen) {
                self.drawNoFavs();
              }
            }, 500);
          });
        })
        .catch(function (err) { console.error('error in fav offers get: ', err); }); // eslint-disable-line no-console

      if (!PageCache.has(cacheId) && !PageCache.isPending(cacheId)) {
        var request = {
          tdaCode: tdaConfig.tda.code,
          zipCode: zip.getCookiedDefaultFallback(),
          offerId: favIdStrings
        };
        PageCache.maybeSet(cacheId, offersService.offers().byOfferId(request));
      }
    },

    analyticsFavs: function (offers) {
      var $scope = this.$el;
      if (offers) {
        anAddContext(
          $scope,
          blocks.offerListBlock({
            count: offers.length,
            layout: 'grid',
            filter: 'favorites',
            selector: 'favorites'
          })
        );
      }
      anPageLoad($scope);
      anClicks($scope);
    },

    favListeners: function () {
      var self = this;
      var $scope = this.$el;
      var $favButton = $('.favorite-button', $scope);
      $favButton.each(function () {
        var $this = $(this);
        self.markFav($this);
        $this.off('click.fav').on('click.fav', function favClick(e) {
          e.preventDefault();
          self.addRemove($this);
        });
      });
    }
  };
});

